<template>
  <div style="margin: 15px 15px 0 15px">
     <b-row class="mt-1">
        <b-col class="ml-1 mr-1" sm="12">
         <b-button-group class="thingroup" style="width:100%"
            v-if="mirror_state == 'off'">
            <b-button            
              class="thinbtn" style="width:100%;"
              variant="success"  size="sm"
              @click="startMirror()">
              Stream to All [{{ title }}]
            </b-button>
         </b-button-group>
         <b-button-group class="thingroup" style="width:100%"
            v-if="mirror_state != 'off'">
            <b-button
              class="thinbtn"  style="width:50%;"
              variant="primary"  size="sm"
              @click="startMirror()">
              Change Source
            </b-button>
            <b-button
              class="thinbtn"  style="width:50%;"
              variant="danger"  size="sm"
              @click="stopMirror()">
              All Stop
            </b-button>
         </b-button-group>
         <div style="font-size: 0.8rem; text-align:center;">
           {{ target }}
         </div>
        </b-col>
     </b-row>

     <b-row>
       <b-col class="mt-2" sm="12">
          <div class="mirror_sep">
             Hide UI
          </div>
       </b-col>
     </b-row>
     <b-row>
       <b-col sm="12">
         <b-button-group class="thingroup" style="width:100%">
           <b-button class="thinbtn" style="width:50%"
             :variant="is_nav_visible ? 'vxon' : 'outline-secondary'"
             @click="setNavVis(true)">
               Show Navbar
             </b-button>
           <b-button class="thinbtn" style="width:50%;"
             :variant="is_nav_visible ? 'outline-secondary' : 'vxon'"
             @click="setNavVis(false)">
               Hide Navbar
             </b-button>
         </b-button-group>
       </b-col>
     </b-row>

     <b-row>
       <b-col class="mt-2" sm="12">
          <div class="mirror_sep">
             Record or Broadcast your Room
          </div>
       </b-col>
     </b-row>
     <b-row>
       <b-col sm="12">
         <b-button-group class="thingroup" style="width:100%">
           <b-button class="thinbtn" style="width:33%;font-size:0.7rem;"
             :disabled="!arc_status.url || cast.changing"
             :variant="cast.priv != 'priv'?'outline-secondary' : cast.variant"
             @click="changeCast('priv')">
               Not Broadcast
             </b-button>
           <b-button class="thinbtn" style="width:33%;font-size:0.7rem;"
             :disabled="!arc_status.url || cast.changing"
             :variant="cast.priv != 'pub1'?'outline-secondary' : cast.variant"
             @click="changeCast('pub1')">
               All {{ acc }}
             </b-button>
           <b-button class="thinbtn" style="width:33%;font-size:0.7rem;"
             :disabled="!arc_status.url || cast.changing"
             :variant="cast.priv != 'pub2'?'outline-secondary' : cast.variant"
             @click="changeCast('pub2')">
               Public to Anyone
             </b-button>
         </b-button-group>
       </b-col>
     </b-row>
     <b-row>
       <b-col sm="12">
          <table style="width:100%;"><tbody>
          <tr>
            <td>
               <div v-if="!showStop(mirrors[0])"
                 class="arc_stat">
                 Make a Recording?
               </div>
               <div v-if="dbhandle && !arc_status.url && showStop(mirrors[0])"
                 class="arc_stat">
                 Recording starting...
               </div>
               <div v-if="arc_status.url && showStop(mirrors[0])">
                 <span v-if="cast.priv == 'priv'"
                   class="arc_stat">
                   Recording
                 </span>
                 <span v-if="cast.priv != 'priv'"
                   class="arc_stat">
                   Recording and showing Broadcast
                 </span>
               </div>
               <div
                 class="arc_stat">
                 {{ displayStatus(mirrors[0]) }}
               </div>
            </td>
            <td>
              <b-button-group class="float-right">
                 <b-button v-if="mirrors[0].status == 'authed'" size="sm"
                  style="margin:0;" @click="addRTMP(mirrors[0])"
                  variant="outline-secondary">
                   Record
                 </b-button>
                 <b-button v-if="showStop(mirrors[0])" size="sm"
                  style="margin:0;" @click="stopRTMP(mirrors[0])"
                  :variant="stopVariant(mirrors[0])">
                   {{ stopText(mirrors[0]) }}
                 </b-button>
              </b-button-group>
            </td>
          </tr>
          <tr v-if="cur_seg_title">
            <td>
               <span style="font-size:0.8rem;color:black;">
               Segment:
               </span>
            </td>
            <td>
               <span style="font-size:0.8rem;font-weight:bold;color:black;">
               {{cur_seg_title}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <b-button size="sm"
               style="margin:0;" @click="newSeg()"
               :Xdisabled="!arc_status.url || !nxt_seg_title"
               variant="primary">
                Mark
              </b-button>
            </td>
            <td>
              <b-input
                v-model.trim="nxt_seg_title"
                placeholder="Segment Name"
              >
              </b-input>
            </td>
          </tr>
          </tbody></table>
       </b-col>
     </b-row>

     <b-row>
       <b-col class="mt-2" sm="12">
          <div class="mirror_sep">
             Stream to a Third Party
          </div>
       </b-col>
     </b-row>
     <b-row>
       <b-col sm="12">
         <b-button-group class="thingroup" style="width:100%">
           <b-button class="thinbtn" style="width:50%"
             :disabled="disablePrivateBtn()"
             :variant="is_private ? 'outline-secondary' : 'vxon'"
             @click="setPrivate(false)">
               Public
             </b-button>
           <b-button class="thinbtn" style="width:50%;"
             :disabled="disablePrivateBtn()"
             :variant="is_private ? 'vxon' : 'outline-secondary'"
             @click="setPrivate(true)">
               Private
             </b-button>
         </b-button-group>
       </b-col>
     </b-row>

     <b-row>
       <b-col sm="12">
         <b-table
           show-empty
           stacked="xxsm"
           :fields="mirrorFields"
           :items="mirrors"
            filter="x"
           :filter-function="mirrorTableShow"
            small
            thead-class="d-none"
            style="font-size:0.75rem"
            empty-text="No active 3rd-party recordings."
          >
            <template v-slot:cell(provider)="data">
               <button v-if="data.item.kind == 'facebook'" size="sm"
                @click="oaSignIn(data.item)"
                class="mirror_prov_btn mirror_prov_fb"
                :disabled="data.item.status != 'login' && data.item.status != 'authed'"
               >
                 Facebook
               </button>
               <button v-if="data.item.kind == 'google'"
                class="mirror_prov_btn mirror_prov_gg"
                @click="oaSignIn(data.item)"
                :disabled="data.item.status != 'login' && data.item.status != 'authed'"
               >
                Youtube
               </button>
               <button v-if="data.item.kind == 'twitch'"
                class="mirror_prov_btn mirror_prov_tw"
                @click="oaSignIn(data.item)"
                :disabled="data.item.status != 'login' && data.item.status != 'authed'"
               >
                Twitch
               </button>
               <span v-if="data.item.kind == 'rtmp'"
                 style="min-width:5rem;margin:0;">
                 {{ data.item.provider ? data.item.provider : "Custom RTMP" }}
               </span>
            </template>
            <template v-slot:cell(status)="data">
               {{ displayStatus(data.item) }}
            </template>
            <template v-slot:cell(ctrls)="data">
               <b-button-group class="float-right">
                 <b-button v-if="data.item.kind != 'archive' && data.item.status == 'authed'" size="sm"
                  style="margin:0;" @click="addRTMP(data.item)"
                  variant="outline-secondary">
                   Add
                 </b-button>
                 <b-button v-if="showStop(data.item)" size="sm"
                  style="margin:0;" @click="stopRTMP(data.item)"
                  :variant="stopVariant(data.item)">
                   {{ stopText(data.item) }}
                 </b-button>
               </b-button-group>
            </template>
         </b-table>
       </b-col>
     </b-row>

             <b-modal id="bv-mirror-rtmp" size="md" hide-footer
                   title="Configure the Service Endpoint">
                <b-form-input
                  id="input-modalName"
                  type="text"
                  v-model.trim="modalName"
                  placeholder="Name, e.g. Twitch"
                ></b-form-input>
                <b-form-input
                  id="input-modalURL"
                  type="text"
                  v-model.trim="modalURL"
                  placeholder="URL, e.g. rtmp://a.rtmp.youtube.com/live2"
                ></b-form-input>
                <b-form-input
                  id="input-modalKEY"
                  type="text"
                  v-model.trim="modalKEY"
                  placeholder="Key, e.g. a1bc-2d34-5ef6-gh78-9ij0"
                ></b-form-input>
                <div style="margin: 0.8rem;">
                  Target: {{ modalURL + (modalKEY ? ("/" + modalKEY) : "") }}
                </div>
                <b-button-group class="">
                  <b-button class="sm" @click="addCustomRTMP"
                    :disabled="!validCustom()">
                    Add
                  </b-button>
                </b-button-group>
                <b-button-group class="float-right">
                  <b-button class="sm" @click="$bvModal.hide('bv-mirror-rtmp')">
                    Cancel
                  </b-button>
                </b-button-group>
             </b-modal>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "mirror",
  data() {
    return {
      acc: "",
      title: "",
      target: "",
      mirror_state: "off",
      mirrors: [],
      mirrorFields: [
        { key: "provider", label: "", tdClass: "mirror_provcol" },
        { key: "status", label: "" },
        { key: "ctrls", label: "" },
      ],
      is_private: true,
      is_nav_visible: true,
      modalName: "",
      modalKEY: "",
      modalURL: "",
      dbhandle: "",//"16243815805pmo25s6mk",
      arc_status: {},
      cast: { priv: "priv",
              variant:"vxon",
              changing: false },
      cur_seg_title: "",
      nxt_seg_title: "",
    }
  },
  components: {
  },
  created() {
    let vue = this;
    /* status:
     *    login    -- needs user to authenticate
     *    authed   -- no url assignment (user needs to select it)
     *    geturl   -- querying for URL
     *    waiting  -- has url assigned, waiting to send to server
     *    sent     -- mirror started, rtmp sent to server
     */
    vue.mirrors.push({
      kind: "archive",
      provider: "_arc",
      status: "authed",
      ctrl: new Archive,
    });
    vue.mirrors.push({
      kind: "facebook",
      provider: "_fbl",
      status: "login",
      ctrl: new FacebookMirror,
    });
    vue.mirrors.push({
      kind: "google",
      provider: "_ggl",
      status: "login",
      ctrl: new YoutubeMirror,
    });
    vue.mirrors.push({
      kind: "twitch",
      provider: "_twh",
      status: "login",
      ctrl: new TwitchMirror,
    });
    /*
    vue.mirrors.push({
      kind: "rtmp",
      provider: "fbrtmp",
      status: "authed",
      url: "rtmps://live-api-s.facebook.com:443/rtmp/1859433050891616?s_bl=1&s_ps=1&s_psm=1&s_sw=0&s_vt=api-s&a=AbyMztxwmNpMlHR4",
    });
    */
    vue.addCustomPlaceholder();
  },
  mounted() {
    let vue = this;
    window.vx_set_room(window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid, "mirror");
    vue.title = "@"+vx.room.main_room;
    vue.acc = vx.acc;
    vue.updateMirror();
    $("body").css("background-color","white");
  },
  methods: {
    mirrorTableShow: function(row,filt) {
      let vue = this;
      if (row.kind == "archive") { return false; }
      return true;
    },
    changeCast: function(val) {
      let vue = this;
      if (vue.cast.changing) { return; }
      vue.cast.priv = val;
      vue.cast.variant = "vxon";

      /* Change made. Apply it. */
      let ar = {};
      ar.handle = vue.dbhandle;
      if (vue.cast.priv == "pub1") {
        ar.pub = true;
        ar.pub_nauth = false;
        ar.cast_add = true;
      } else if (vue.cast.priv == "pub2") {
        ar.pub = true;
        ar.pub_nauth = true;
        ar.cast_add = true;
      } else {
        ar.pub = false;
        ar.pub_nauth = false;
        ar.cast_rem = true;
      }
      vue.cast.changing = true;
      api_arcupdate(window.vx, ar, function(j) {
         vue.cast.changing = false;
      });
    },
    startMirror: function() {
      let vue = this;
      let rq = {target:"mirror",cmd:"start"};
      let tm = Date.now()/100;
      let id = "";
      while (tm > 0) {
        id = window.vx_fake62(tm) + id;
        tm = Math.trunc(tm / 62);
      }
      for (let i=0; i<10; i++) {
        id = id + window.vx_fake62(62*Math.random());
      }
      vue.dbhandle = id;
      rq.opt = {handle: ""+vue.dbhandle};
      console.log("Start Mirroring "+vue.dbhandle);
      vue.$parent.mydevice.msg_opener(rq, function(msg) {
         vue.target = "@"+msg._room;
         if (msg.error || !msg.state) {
           console.log("error:"+msg.error);
           return;
         }
         vue.mirror_state = msg.state;
      });
    },
    stopMirror: function() {
      let vue = this;
      vue.mirrors.forEach(function(m) {
        if (!m.ctrl) { return; }
        if (!vue.showStop(m)) { return; }
        m.ctrl.stop(function() {
        }, function() {
          console.log(m.kind+": stopped\n");
        });
      });
      vue.$parent.mydevice.msg_opener({target:"mirror",cmd:"stop"}, function(msg) {
         vue.mirror_state = msg.state;
         vue.dbhandle = "";
         vue.arc_status = {};
         vue.cast.priv = "priv";
         vue.cast.variant = "vxon";
         vue.cast.changing = false;
         vue.target = "";
      });
    },
    updateMirror: function() {
      let vue = this;
      if (!window.opener) {
         window.close();
      }
      if (!vue.dbhandle) {
        vue.arc_status = {};
      } else if (!vue.cast.changing) {
        /* No change made or inflight */
        api_arclist(window.vx, {handle: vue.dbhandle}, function(j) {
          //]console.log("arclist",JSON.stringify(j));
          if (!j || !j.a || !j.a[0]) {
            vue.arc_status = {};
            return;
          }
          let stat = j.a[0];
          vue.arc_status = stat;
          if (!stat.pub) {
            vue.cast.priv = "priv";
            vue.cast.variant = "vxon";
          } else {
            if (!stat.pub_nauth) {
              vue.cast.priv = "pub1";
            } else {
              vue.cast.priv = "pub2";
            }
            if (!j.cast || !j.cast.handle) {
              /* Mirror menu only allows for
                 public + broadcast. Must have been
                 changed elsewhere. */
              vue.cast.variant = "outline-warning";
            } else {
              vue.cast.variant = "vxon";
            }
          }
        });
      }

      vue.mirrors.forEach(function(m) {
        if (!m.ctrl) { return; }
        if (m.status != "login") { return; }
        m.ctrl.valid_oauth(function(v,n) {
           if (!v) { return; }
           m.status = "authed";
           m.who = n;
        });
      });
      vue.$parent.mydevice.msg_opener({target:"mirror",cmd:"state"}, function(msg) {
          if (msg.error) { return; }
          vue.mirror_state = msg.state;
          vue.delCustomPlaceholder();
          vue.mirrors.forEach(function(m) {
            m.updated = false;
          });
          msg.status.forEach(function(r) {
             let found = false;
             vue.mirrors.forEach(function(m) {
               if (m.provider == r.provider) {
                 m.status = r.status;
                 m.updated = true;
                 found = true;
               }
             });
             if (!found) {
                vue.mirrors.push({
                   kind: "rtmp",
                   provider: r.provider,
                   status: r.status,
                   url: "xyz", // Anything non-empty
                   updated: true,
                });
             }
          });
          vue.mirrors = vue.mirrors.filter(function(m) {
            /* No status for this */
            if (m.kind == "rtmp") {
               if (m.updated) { return true; }
               if (m.status == "login" || m.status == "authed") {
               } else if (m.status == "stopping") {
                 return false;
               } else if (m.status == "sent" &&
                          vue.mirror_state == 'off') {
                 return false;
               }
            } else { /* facebook/google/etc. */
               if (m.status == "login" || m.status == "authed") {
               } else if (!m.updated || vue.mirror_state == 'off') {
                  /* No record or mirroring not active */
                 if (m.status == "stopping" || m.status == "sent") {
                    m.status = "login";
                    if (m.ctrl) {
                      m.ctrl.stop();
                      m.ctrl.valid_oauth(function(v,n) {
                      if (!v) { return; }
                        m.status = "authed";
                        m.who = n;
                      });
                    }
                 }
               } else if (m.status == "sent") {
                   if (m.ctrl) {
                     m.ctrl.getState(function() {
                     },function(state) {
                       m.provider_state = state;
                       if (state == "stopped") {
                          /* Tell mirror source it's gone. */
                          vue.stopRTMP(m);
                       }
                     });
                   }
               }
            } /* facebook/google/etc. */
            return true;
          });
          vue.addCustomPlaceholder();
       });
       vue.state_tid = window.setTimeout(function() {
         vue.updateMirror();
       }, 5000);
    },
    addRTMP: function(item) {
       let vue = this;
       let cmd = {target:"mirror",cmd:"addRTMP", opt:{}};
       if (item.kind != "rtmp") {
           let priv = vue.is_private;
           item.status = "geturl";
           item.ctrl.getUrl("rtmp", priv, function() {
             console.warn(item.kind+": Failed to get URL\n");
             item.status = "login";
           }, function(url) {
             cmd.opt.provider = item.provider;
             cmd.opt.url = item.url = url;
             item.status = "waiting";
             vue.$parent.mydevice.msg_opener(cmd, function(msg) {
               if (msg.error) {
                  console.log("error:"+msg.error);
                  item.ctrl.stop();
                  item.status = "authed";
                  return;
               }
               if (item.ctrl.registerChatCallback) {
                 item.ctrl.registerChatCallback(3000, function() {
                   console.warn("registerChatCallback failed");
                 }, function(msgs) {
                   for (let i = 0; i < msgs.length; i++) {
                     vue.$parent.mydevice.msg_opener({
                        target:"wss",
                        cmd:"msg_to",
                        opt:{
                           to:{room:true},
                           msg:msgs[i].msg,
                           ext:{
                             author: msgs[i].author,
                             authorid: msgs[i].authorid,
                             provider: msgs[i].provider,
                           },
                        },
                     });
                   }
                 });
               }
             });
           });
       } else {
           if (!item.url) {
             /* Custom RTMP */
             vue.$bvModal.show('bv-mirror-rtmp');
           } else {
             cmd.opt.provider = item.provider;
             cmd.opt.url = item.url;
             item.status = "waiting";
             vue.$parent.mydevice.msg_opener(cmd, function(msg) {
               if (msg.error) {
                  console.log("error:"+msg.error);
                  item.status = "authed";
                  return;
               }
             });
           }
       }
    },
    stopRTMP: function(item) {
       let vue = this;
       let cmd = {target:"mirror",cmd:"stopRTMP", opt:{}};
       if (!item || !item.provider) { return; }
       cmd.opt.provider = item.provider;
       item.status = "stopping";
       if (item.ctrl) {
         item.ctrl.stop(function() {
           console.warn(item.provider+": stop failed\n");
         }, function() {
           console.log(item.provider+": stopped\n");
         });
       }
       vue.$parent.mydevice.msg_opener(cmd, function(msg) {
          console.log(JSON.stringify(cmd),JSON.stringify(msg));
       });
    },
    newSeg: function() {
      let vue = this;
      let cmd = {target:"mirror",cmd:"metaseg", opt:{}};
      cmd.opt.txt = vue.nxt_seg_title;
      vue.$parent.mydevice.msg_opener(cmd, function(msg) {
         vue.cur_seg_title = vue.nxt_seg_title;
         vue.nxt_seg_title = "";
      });
    },
    addCustomPlaceholder: function() {
       let vue = this;
       vue.mirrors.push({
        kind: "rtmp",
        status: "authed",
       });
    },
    delCustomPlaceholder: function() {
       let vue = this;
       vue.mirrors.pop();
    },
    validCustom: function() {
       let vue = this;
       let found = false;
       if (!vue.modalURL || !vue.modalName) {
         return false;
       }
       vue.mirrors.forEach(function(m) {
         if (m.provider == vue.modalName) {
            found = true;
         }
       });
       if (found) { return false; }
       return true;
    },
    addCustomRTMP: function() {
       /* Called from modal */
       let vue = this;
       let url = "";
       vue.$bvModal.hide('bv-mirror-rtmp')
       if (vue.modalKEY) {
         url = vue.modalURL + "/" + vue.modalKEY;
       } else {
         url = vue.modalURL;
       }
       vue.delCustomPlaceholder();
       let m = {};
       m.kind = "rtmp";
       m.provider = vue.modalName;
       m.url = url;
       m.status = "authed";
       vue.mirrors.push(m);
       vue.addRTMP(m);

       vue.modalName = "";
       vue.modalURL = "";
       vue.modalKEY = "";
       vue.addCustomPlaceholder();
    },
    showStop: function(item) {
      if (item.status == "waiting" ||
          item.status == "sent") {
          return true;
      }
      return false;
    },
    stopVariant: function(item) {
      if (item.status == "waiting") {
        return "outline-danger";
      }
      return "danger";
    },
    stopText: function(item) {
      if (item.status == "waiting") {
        return "Del";
      }
      if (item.kind == "archive") {
        return "Pause";
      }
      return "Stop";
    },
    displayStatus: function(item) {
      let vue = this;
      if (item.kind == "archive") {
         let status = "";
         if (vue.arc_status.handle) {
           let done = vue.arc_status.done || false;
           let dur = vue.arc_status.dur ? (vue.arc_status.dur/1000) : 0;
           let active = false;
           if (vue.arc_status.cur_ms && vue.arc_status.last_ms &&
               ((vue.arc_status.cur_ms - vue.arc_status.last_ms)/1000) < 5) {
               active = true;
           }
           if (false && done) {
             status = "Complete";
           } else {
             status = dur.toFixed(1)+" sec";
             if (item.status == "waiting") {
               status += " (reactivating)";
             } else if (item.status == "stopping") {
               status += " (pausing)";
             } else if (!active) {
               status += " (paused)";
             }
           }
         } else {
           if (item.status == "waiting") {
              return "Waiting for Start";
           }
         }
         if (item.status == "login" || item.status == "authed") {
           return status;
         } else if (item.status == "sent" || item.status == "waiting" ||
                    item.status == "stopping") {
           return status;
         } else if (item.status == "geturl") {
           return "Setting up...";
         } else {
           return status;
         }
      } else if (item.status == "waiting") {
        return "Waiting for Start";
      } else if (item.status == "stopping") {
        return "Stopping...";
      } else if (item.kind != "rtmp") {
         if (item.status == "login") {
           return "Click to Sign In";
         } else if (item.status == "authed") {
           if (item.who) {
           return "Authenticated as "+item.who;
           }
           return "Authenticated";
         } else if (item.status == "sent") {
           if (!item.provider_state || item.provider_state == "live") {
              return "LIVE";
           } else {
              return "LIVE, Error";
           }
         } else if (item.status == "geturl") {
           return "Setting up...";
         } else {
           return item.status;
         }
      } else {
         if (!item.url) {
           return "";
         } else if (item.status == "sent") {
           return "LIVE";
         } else if (item.status == "authed") {
           return "URL Ready";
         } else {
           return item.status;
         }
      }
    },
    oaSignIn: function(item) {
      let vue = this;
      if (!item.ctrl) { return; }
      let resume = window.location.pathname+vue.$router.resolve({name: 'mirror'}).href;
      if (item.status == "authed") {
         // In this one case, force a full refresh
         item.ctrl.reset();
         item.status = "login";
      }
      item.ctrl.oauth(resume,
      function() {
        console.log("oauth error");
      }, function() {
        item.status = "authed";
      });
    },
    setPrivate: function(v) {
      let vue = this;
      vue.is_private = v;
    },
    setNavVis: function(v) {
      let vue = this;
      let cmd = {target:"mirror",cmd:"navbar", opt:{vis:v}};
      vue.$parent.mydevice.msg_opener(cmd, function(msg) {
         vue.is_nav_visible = v;
       });
    },
    disablePrivateBtn() {
       let vue = this;
       let disable = false;
       vue.mirrors.forEach(function(m) {
         if (m.kind == "rtmp") { return; }
         if (m.kind == "archive") { return; }
         if (m.status != "login" && m.status != "authed") {
           /* Once URL assigned or streaming started => cannot change */
           disable = true;
         }
       });    
      return disable;
    },
  },
  computed: {
  },
  beforeDestroy() {
    let vue = this;
    window.clearTimeout(vue.state_tid);
  }
};
</script>

<style lang="scss">
.mirror_sep {
  text-align: center;
  border-bottom: 2px solid black;
  font-size: 0.9rem;
  font-weight: bold;
}
.arc_stat {
  font-size:0.8rem;
}

.mirror_provcol {
  width: 6rem;
}
.mirror_prov_btn {
  /*height:1.5rem;*/
  color:transparent;
  width:5rem;
  margin:0;
  background-size:contain;
  background-repeat:no-repeat;
  /*background-position-x: 1px;*/
  background-position-y: 1px;
  border: solid 1px black;
  border-radius: 3px;  
}
.mirror_prov_fb {
  background-image:url('../assets/img/Facebook_Live_400x90_centered.png');
}
.mirror_prov_gg {
  background-image:url('../assets/img/YouTube_400x90_centered.png');
}
.mirror_prov_tw {
  background-image:url('../assets/img/Twitch_400x90_centered.png');
}
.mirror_prov_arc {
  color: black;
}

</style>
